import * as c from '../helpers/constants'
import { getToken, isAuthenticated } from '../store/auth';
import { callApi } from '../helpers/methods';

const constants = {    
    NEW_CAMPAIGN: 'NEW_CAMPAIGN',
    
    SAVE_CAMPAIGN_REQUEST: 'SAVE_CAMPAIGN_REQUEST',
    SAVE_CAMPAIGN_SUCCESS: 'SAVE_CAMPAIGN_SUCCESS',
    SAVE_CAMPAIGN_FAILURE: 'SAVE_CAMPAIGN_FAILURE',

    SAVE_EDITOR: 'SAVE_EDITOR',

    SAVE_TEMPLATE_REQUEST: 'SAVE_TEMPLATE_REQUEST',
    SAVE_TEMPLATE_SUCCESS: 'SAVE_TEMPLATE_SUCCESS',
    SAVE_TEMPLATE_FAILURE: 'SAVE_TEMPLATE_FAILURE',

    SAVE_ARQUIVO_TEMPLATE_REQUEST: 'SAVE_ARQUIVO_TEMPLATE_REQUEST',
    SAVE_ARQUIVO_TEMPLATE: 'SAVE_ARQUIVO_TEMPLATE',
    SAVE_ARQUIVO_TEMPLATE_FAILURE: 'SAVE_ARQUIVO_TEMPLATE_FAILURE',

    SAVE_CHECKLIST_REQUEST: 'SAVE_CHECKLIST_REQUEST',
    SAVE_CHECKLIST_SUCCESS: 'SAVE_CHECKLIST_SUCCESS',
    SAVE_CHECKLIST_FAILURE: 'SAVE_CHECKLIST_FAILURE',

    SEND_REQUEST: 'SEND_REQUEST',
    SEND_SUCCESS: 'SEND_SUCCESS',
    SEND_FAILURE: 'SEND_FAILURE',

    SET_ARQUIVO_TEMPLATE: 'SET_ARQUIVO_TEMPLATE',

    FINISH: 'FINISH'
};

const initialState = {
    campanha: undefined,
    editor: undefined,
    template: undefined,
    checklist: undefined,
    
    exception: undefined,
    isSent: false,
    isFinished: false
};

export const campanhaAction = {

    novaCampanha: () => async (dispatch, getState) =>
    {
        dispatch({ type: constants.NEW_CAMPAIGN });
    },

    salvarCampanha: (form) => async (dispatch, getState) =>
    {
        if (!form.auth.isAuthenticated) throw (c.MESSAGE_ERROR(c.AUTH_ERROR));

        const _token = c.AUTH_HEADER(getToken());
        
        const url = `${ c.API_BASE_URL }/campaign`;
        const options = {
             method: 'POST' // method: 'POST'
            ,headers: { 'Content-Type': 'application/json', 'Authorization': _token },
             body: JSON.stringify(form)
        };

        dispatch({ type: constants.SAVE_CAMPAIGN_REQUEST });

        return await fetch(url, options).then(async (response) => {
            let json = await response.json();
            dispatch({ type: constants.SAVE_CAMPAIGN_SUCCESS, form: form }); return json;

        }).catch((exception) => {
            dispatch({ type: constants.SAVE_CAMPAIGN_FAILURE, exception: exception }); throw (exception);
        });
    },

    salvarEditor: (editor) => async (dispatch, getState) =>
    {
        dispatch({ type: constants.SAVE_EDITOR, tipo: editor });
    },

    salvarIdArquivoTemplate: (idArquivo) => async (dispatch, getState) =>
    {
        dispatch({ type: constants.SAVE_ARQUIVO_TEMPLATE, idArquivoTemplate: idArquivo });
    },

    setArquivoTemplate: (payload) => async (dispatch) => {
        dispatch({ type: constants.SET_ARQUIVO_TEMPLATE, payload });
    },

    salvarTemplate: (form, idCampanha, editor, idArquivoTemplate,tipoTemplate) => async (dispatch, getState) =>
    {

        if (!isAuthenticated()) throw (c.MESSAGE_ERROR(c.AUTH_ERROR));

        const _token = c.AUTH_HEADER(getToken());

        let template = {
            id: form.id,
            nome: form.nome,
            mensagem: form.mensagem,
            editor: editor,
            idArquivo: idArquivoTemplate,
            tipoTemplate: tipoTemplate,
            url: form.url, 
            idEmpresa: form.empresa.id
        };
        
        const url = `${ c.API_CAMPAIGN_URL }/addTemplateToCampaign/${idCampanha}`;
        const options = {
             method: 'PUT'
            ,headers: { 'Content-Type': 'application/json', 'Authorization': _token }
            ,body: JSON.stringify(template)
        };

        dispatch({ type: constants.SAVE_TEMPLATE_REQUEST });

        return await fetch(url, options).then(async (response) => 
        {
            let json = await response.json();
            if (!response.ok) throw (json); 
            dispatch({ type: constants.SEND_SUCCESS }); return json;

        }).catch((exception) => 
        {
            dispatch({ type: constants.SAVE_TEMPLATE_FAILURE, exception: exception }); throw (exception);
        });
    },

    salvarChecklist: (form, campanhaId, auth) => async (dispatch, getState) =>
    {
        if (!isAuthenticated()) throw (c.MESSAGE_ERROR(c.AUTH_ERROR));

        const _token = c.AUTH_HEADER(getToken());
        
        const url = `${ c.API_CAMPAIGN_URL }/campaign/fluxo/check-list/${campanhaId}`;
        const options = {
             method: 'PUT'
            ,headers: { 'Content-Type': 'application/json', 'Authorization': _token }
            ,body: JSON.stringify(form)
        };

        dispatch({ type: constants.SAVE_CHECKLIST_REQUEST });

        return await fetch(url, options).then(async (response) => 
        {
            if (response.ok) {  
                dispatch({ type: constants.SAVE_CHECKLIST_SUCCESS, form: form });           
            }

            let json = await response.json();
            
            return json;

        }).catch((exception) => 
        {
            dispatch({ type: constants.SAVE_CHECKLIST_FAILURE, exception: exception }); 
            throw (exception);
        });
    },

    enviar: (form) => async (dispatch, getState) =>
    {
        if (!isAuthenticated()) throw (c.MESSAGE_ERROR(c.AUTH_ERROR));

        const _token = c.AUTH_HEADER(getToken());
        
        const url = `${ c.API_BASE_URL }/campaign`;
        const options = {
             method: 'POST'
            ,headers: { 'Content-Type': 'application/json', 'Authorization': _token }
            ,body: JSON.stringify(form.campanha)
        };

        dispatch({ type: constants.SEND_REQUEST });

        return await fetch(url, options).then(async (response) => 
        {
            let json = await response.json();

            if (!response.ok) throw (json); 

            dispatch({ type: constants.SEND_SUCCESS }); return json;

        }).catch((exception) => 
        {
            dispatch({ type: constants.SEND_FAILURE, exception: exception }); throw (exception);
        });
    },

    update: (form) => async (dispatch, getState) =>
    {
        if (!isAuthenticated()) throw (c.MESSAGE_ERROR(c.AUTH_ERROR));

        const _token = c.AUTH_HEADER(getToken());

        let idCampanha = form.campanha.id;
        
        const url = `${ c.API_BASE_URL }/campaign/${idCampanha}`;
        const options = {
             method: 'PUT'
            ,headers: { 'Content-Type': 'application/json', 'Authorization': _token }
            ,body: JSON.stringify(form.campanha)
        };

        dispatch({ type: constants.SEND_REQUEST });

        return await fetch(url, options).then(async (response) => 
        {
            let json = await response.json();

            if (!response.ok) throw (json); 

            dispatch({ type: constants.SEND_SUCCESS }); return json;

        }).catch((exception) => 
        {
            dispatch({ type: constants.SEND_FAILURE, exception: exception }); throw (exception);
        });
    },

    salvarPassoUm: (form, auth) => async (dispatch, getState) =>
    {
        if (!isAuthenticated()) throw (c.MESSAGE_ERROR(c.AUTH_ERROR));

        const _token = c.AUTH_HEADER(getToken());

        const url = `${ c.API_CAMPAIGN_URL }/campaign/fluxo/passo-one`;
        const options = {
             method: 'POST'
            ,headers: { 'Content-Type': 'application/json', 'Authorization': _token }
            ,body: JSON.stringify(form)
        };

        dispatch({ type: constants.SAVE_CAMPAIGN_REQUEST });

        return await fetch(url, options).then(async (response) => 
        {
            let json = await response.json();

            if (!response.ok) throw (json); 

            dispatch({ type: constants.SEND_SUCCESS }); return json;

        }).catch((exception) => 
        {
            dispatch({ type: constants.SEND_FAILURE, exception: exception }); throw (exception);
        });
    },

    editarPassoUm: (form, auth, idCampanha) => async (dispatch, getState) =>
    {
        if (!isAuthenticated()) throw (c.MESSAGE_ERROR(c.AUTH_ERROR));

        const _token = c.AUTH_HEADER(getToken());

        const url = `${ c.API_CAMPAIGN_URL }/campaign/fluxo/passo-one/${idCampanha}`;
        const options = {
             method: 'PUT'
            ,headers: { 'Content-Type': 'application/json', 'Authorization': _token }
            ,body: JSON.stringify(form)
        };

        dispatch({ type: constants.SAVE_CAMPAIGN_REQUEST });

        return await fetch(url, options).then(async (response) => 
        {
            let json = await response.json();

            if (!response.ok) throw (json); 

            dispatch({ type: constants.SEND_SUCCESS }); return json;

        }).catch((exception) => 
        {
            dispatch({ type: constants.SEND_FAILURE, exception: exception }); throw (exception);
        });
    },

    finalizar: (form) => async (dispatch, getState) =>
    {
        dispatch({ type: constants.FINISH });
    }
};

export const reducer = (state, action) => {

    state = state || initialState;

    switch (action.type)
    {   
        case constants.NEW_CAMPAIGN:
            return {
                campanha: undefined,
                editor: undefined,
                template: undefined,
                checklist: undefined,
                error: undefined,
                isSend: false,
                isFinished: false
            };

        case constants.SAVE_CAMPAIGN_REQUEST:
            return {
                ...state,
                idCampanha: '',
                urlRetorno: '',
            };

        case constants.SAVE_CAMPAIGN_SUCCESS:
            return {
                ...state,
                campanha: { isSubmitted: true, form: action.form }
            };

        case constants.SAVE_CAMPAIGN_FAILURE:
            return {
                ...state,
                campanha: {},
                exception: action.exception,
            };

        case constants.SAVE_EDITOR:
            return {
                ...state,
                editor: { isSubmitted: true, type: action.tipo }
            };

        case constants.SAVE_TEMPLATE_REQUEST:
            return {
                ...state,
                template: {},
            };

        case constants.SAVE_TEMPLATE_SUCCESS:
            return {
                ...state,
                template: { isSubmitted: true, form: action.form }
            };

        case constants.SAVE_TEMPLATE_FAILURE:
            return {
                ...state,
                template: {},
                exception: action.exception,
            };

        case constants.SAVE_ARQUIVO_TEMPLATE:
            return {
                ...state,
                arquivoTemplate: {isSubmitted: true, idArquivoTemplate: action.idArquivoTemplate},
            };

        case constants.SAVE_CHECKLIST_REQUEST:
            return {
                ...state,
                checklist: {}
            };

        case constants.SAVE_CHECKLIST_SUCCESS:
            return {
                ...state,
                template: '',
                checklist: { isSubmitted: true, form: action.form }
            };

        case constants.SAVE_CHECKLIST_FAILURE:
            return {
                ...state,
                checklist: {},
                exception: action.exception,
            };

        case constants.SEND_REQUEST:
            return {
                ...state,
                isSent: false
            };

        case constants.SEND_SUCCESS:
            return {
                ...state,
                isSent: true
            };

        case constants.SEND_FAILURE:
            return {
                ...state,
                isSent: false,
                exception: action.exception,
            };

        case constants.SET_ARQUIVO_TEMPLATE:
            return {
                ...state,
                arquivoTemplate: action.payload
                    ? { isSubmitted: true, idArquivoTemplate: action.payload.idArquivoTemplate }
                    : null
            };

        case constants.FINISH:
            return {
                ...state,
                isFinished: true
            };

        default: return state;
    }
}
